import { Link } from "react-router-dom"
import logo from "../../assets/img/Recurso 2.png"
import { useEffect } from "react"
import { Applicacion } from "../../assets/js/app"
import { useSelector } from "react-redux"
import { RootState } from "../../redux/store"
import {MdLocalShipping} from "react-icons/md"
import '../../plugins/perfect-scrollbar/perfect-scrollbar.css'
import { RolesUsuarios } from "../useAuth/useAuth"
const SideBar = () => {
    const existeNavBar = window.document.getElementsByClassName('menu-categories')
    const existeSideBar = window.document.getElementsByClassName('dropdown-toggle')
    let puedeEjecutar = false 

    useEffect(() => {
        if (existeNavBar.length > 0 && existeSideBar.length && !puedeEjecutar ) {
            //Jquery
            puedeEjecutar = true
            Applicacion.init()
        }
    }, [existeNavBar, existeSideBar])

    const usuarioVM = useSelector((state: RootState) => state.auth.usuarioActual)
    return (
        <div className="sidebar-wrapper sidebar-theme">

            <nav id="sidebar">
                <div className="profile-info">
                    <figure className="user-cover-image"> </figure>
                    <div className="user-info">
                        <Link to="/home">
                            <img src={logo} alt="logo" />
                        </Link>
                        <p >Soluciones Logísticas</p>
                    </div>
                </div>
                <div className="shadow-bottom"></div>
                {usuarioVM.rolUsuario === RolesUsuarios.CONDUCTOR?
                //Inicio SideBar para conductores
                    <ul className="list-unstyled menu-categories" id="accordionExample">
                        <li className="menu active">
                            <Link to="#" data-toggle="collapse" aria-expanded="true" className="dropdown-toggle">
                                <div className="">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                                        strokeLinejoin="round" className="feather feather-home">
                                        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                                        <polyline points="9 22 9 12 15 12 15 22"></polyline>
                                    </svg>
                                    <span>HOME</span>
                                </div>
                            </Link>
                        </li>

                        <li className="menu menu-heading">
                            <div className="heading"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
                                strokeLinecap="round" strokeLinejoin="round" className="feather feather-minus">
                                <line x1="5" y1="12" x2="19" y2="12"></line>
                            </svg><span>LOGÍSTICA</span></div>
                        </li>

                        <li className="menu">
                            <a href="#crear" data-toggle="collapse" aria-expanded="false" className="dropdown-toggle">
                                <style>
                                    {`#camionSvg path:first-child {
                                        display: none; 
                                    }`/*Eliminamos el primer path del svg por errores de diseño*/ }  
                                </style>
                                <div className="">
                                    <MdLocalShipping id="camionSvg"/>
                                    <span>RUTA</span>
                                </div>
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                                        strokeLinejoin="round" className="feather feather-chevron-right">
                                        <polyline points="9 18 15 12 9 6"></polyline>
                                    </svg>
                                </div>
                            </a>
                            <ul className="collapse submenu list-unstyled" id="crear" data-parent="#accordionExample">
                                <li>
                                    <Link to="/home/liquidarRuta">Liquidar Ruta</Link>
                                </li>
                            </ul>
                        </li>

                        <li className="menu menu-heading">
                            <div className="heading"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
                                strokeLinecap="round" strokeLinejoin="round" className="feather feather-minus">
                                <line x1="5" y1="12" x2="19" y2="12"></line>
                            </svg><span>USUARIO</span></div>
                        </li>

                        <li className="menu">
                            <a href="#users" data-toggle="collapse" aria-expanded="false" className="dropdown-toggle">
                                <div className="">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                                        strokeLinejoin="round" className="feather feather-users">
                                        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                                        <circle cx="9" cy="7" r="4"></circle>
                                        <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                                        <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                                    </svg>
                                    <span>USUARIO</span>
                                </div>
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                                        strokeLinejoin="round" className="feather feather-chevron-right">
                                        <polyline points="9 18 15 12 9 6"></polyline>
                                    </svg>
                                </div>
                            </a>
                            <ul className="collapse submenu list-unstyled" id="users" data-parent="#accordionExample">
                                <li>
                                    <Link to="/home/usuario"> Perfil de Usuario </Link>
                                </li>
                            </ul>
                        </li>

                    </ul>
                //Fin SideBar Para conductores
                : usuarioVM.rolUsuario === RolesUsuarios.COMUN?
                //Inicio SideBar para usuarios logeado
                <ul className="list-unstyled menu-categories" id="accordionExample">
                        <li className="menu active">
                            <Link to="/home" data-toggle="collapse" aria-expanded="true" className="dropdown-toggle">
                                <div className="">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                                        strokeLinejoin="round" className="feather feather-home">
                                        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                                        <polyline points="9 22 9 12 15 12 15 22"></polyline>
                                    </svg>
                                    <span>HOME</span>
                                </div>
                            </Link>
                        </li>
                        <li className="menu menu-heading">
                            <div className="heading"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
                                strokeLinecap="round" strokeLinejoin="round" className="feather feather-minus">
                                <line x1="5" y1="12" x2="19" y2="12"></line>
                            </svg><span>LOGÍSTICA</span></div>
                        </li>
                        <li className="menu">
                            <a href="#crear" data-toggle="collapse" aria-expanded="false" className="dropdown-toggle">
                                <div className="">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                                        strokeLinejoin="round" className="feather feather-box">
                                        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                                        <circle cx="9" cy="7" r="4"></circle>
                                        <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                                        <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                                    </svg>
                                    <span>CREAR</span>
                                </div>
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                                        strokeLinejoin="round" className="feather feather-chevron-right">
                                        <polyline points="9 18 15 12 9 6"></polyline>
                                    </svg>
                                </div>
                            </a>
                            <ul className="collapse submenu list-unstyled" id="crear" data-parent="#accordionExample">
                                <li>
                                    <Link to="/home/crear/guia">Guía </Link>
                                </li>
                                <li>
                                    <Link to="/home/crear/resumenGuia">Resumen de Guías </Link>
                                </li>

                            </ul>
                        </li> 


                        <li className="menu">
                            <a href="#Consultar" data-toggle="collapse" aria-expanded="false" className="dropdown-toggle">
                                <div className="">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                                        strokeLinejoin="round" className="feather feather-zap">
                                        <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
                                    </svg>
                                    <span>CONSULTAS</span>
                                </div>
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                                        strokeLinejoin="round" className="feather feather-chevron-right">
                                        <polyline points="9 18 15 12 9 6"></polyline>
                                    </svg>
                                </div>
                            </a>
                            <ul className="collapse submenu list-unstyled" id="Consultar" data-parent="#accordionExample">
                                <li>
                                    <Link to={"/home/consulta/guia"}>Guia</Link>
                                </li>
                                <li>
                                    <Link to={"/home/consulta/resumenGuias"}>Resumen de Guias</Link>
                                </li>
                                <li>
                                    <Link to={"/home/consulta/destinatarios"}>Mis Destinatarios</Link>

                                </li>
                                {/* <li>
                                    <Link to={"/home/consulta/indicadores"}>Indicadores de gestion</Link>
                                </li> */}
                            </ul>
                        </li>
                        <li className="menu menu-heading">
                            <div className="heading"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
                                strokeLinecap="round" strokeLinejoin="round" className="feather feather-minus">
                                <line x1="5" y1="12" x2="19" y2="12"></line>
                            </svg><span>USUARIO</span></div>
                        </li>

                        <li className="menu">
                            <a href="#users" data-toggle="collapse" aria-expanded="false" className="dropdown-toggle">
                                <div className="">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                                        strokeLinejoin="round" className="feather feather-users">
                                        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                                        <circle cx="9" cy="7" r="4"></circle>
                                        <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                                        <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                                    </svg>
                                    <span>USUARIO</span>
                                </div>
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                                        strokeLinejoin="round" className="feather feather-chevron-right">
                                        <polyline points="9 18 15 12 9 6"></polyline>
                                    </svg>
                                </div>
                            </a>
                            <ul className="collapse submenu list-unstyled" id="users" data-parent="#accordionExample">
                                <li>
                                    <Link to="/home/usuario"> Perfil de Usuario </Link>
                                </li>
                            </ul>
                        </li>
                      
                    </ul>
                :
                <ul className="list-unstyled menu-categories" id="accordionExample">
               
                <li className="menu menu-heading">
                    <div className="heading"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                        viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
                        strokeLinecap="round" strokeLinejoin="round" className="feather feather-minus">
                        <line x1="5" y1="12" x2="19" y2="12"></line>
                    </svg><span>CONTACTANOS</span></div>
                </li>

                <li className="menu">
                    <a href="#pages" data-toggle="collapse" aria-expanded="false" className="dropdown-toggle">
                        <div className="">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                                strokeLinejoin="round" className="feather feather-file">
                                <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path>
                                <polyline points="13 2 13 9 20 9"></polyline>
                            </svg>
                            <span>CONTÁCTANOS</span>
                        </div>
                        <div>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                                strokeLinejoin="round" className="feather feather-chevron-right">
                                <polyline points="9 18 15 12 9 6"></polyline>
                            </svg>
                        </div>
                    </a>
                    <ul className="collapse submenu list-unstyled" id="pages" data-parent="#accordionExample">
                        <li>
                            <Link to={"/home/contactanos"}>Formulario de Contacto </Link>
                        </li>

                    </ul>
                </li>
              
            </ul>
                
                //Fin SideBar Para usuarios comunes
                
            }

            </nav>
        </div>
    )
}

export default SideBar

/*
        <div className="sidebar-wrapper sidebar-theme">

            <nav id="sidebar">
                <div className="profile-info">
                    <figure className="user-cover-image"> </figure>
                    <div className="user-info">
                       
                        
                    </div>

                </div>
                <div className="shadow-bottom"></div>
                <ul className="list-unstyled menu-categories" id="accordionExample">
                    <li className="menu active">
                        <Link to="/home" data-toggle="collapse" aria-expanded="true" className="dropdown-toggle">
                            <div className="">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                                    strokeLinejoin="round" className="feather feather-home">
                                    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                                    <polyline points="9 22 9 12 15 12 15 22"></polyline>
                                </svg>
                                <span>HOME</span>
                            </div>
                        </Link>
                    </li>



                    <li className="menu menu-heading">
                        <div className="heading"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
                                strokeLinecap="round" strokeLinejoin="round" className="feather feather-minus">
                                <line x1="5" y1="12" x2="19" y2="12"></line>
                            </svg><span>LOGÍSTICA</span></div>
                    </li>

                    <li className="menu">
                        <a href="#crear" data-toggle="collapse" aria-expanded="false" className="dropdown-toggle">
                            <div className="">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                                    strokeLinejoin="round" className="feather feather-box">
                                    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                                    <circle cx="9" cy="7" r="4"></circle>
                                    <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                                    <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                                </svg>
                                <span>CREAR</span>
                            </div>
                            <div>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                                    strokeLinejoin="round" className="feather feather-chevron-right">
                                    <polyline points="9 18 15 12 9 6"></polyline>
                                </svg>
                            </div>
                        </a>
                        <ul className="collapse submenu list-unstyled" id="crear" data-parent="#accordionExample">
                           

                        </ul>
                    </li>


                    <li className="menu">
                        <a href="#Consultar" data-toggle="collapse" aria-expanded="false" className="dropdown-toggle">
                            <div className="">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                                    strokeLinejoin="round" className="feather feather-zap">
                                    <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
                                </svg>
                                <span>CONSULTAS</span>
                            </div>
                            <div>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                                    strokeLinejoin="round" className="feather feather-chevron-right">
                                    <polyline points="9 18 15 12 9 6"></polyline>
                                </svg>
                            </div>
                        </a>
                        <ul className="collapse submenu list-unstyled" id="Consultar" data-parent="#accordionExample">
                            
                        </ul>
                    </li>

                    <li className="menu menu-heading">
                        <div className="heading"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
                                strokeLinecap="round" strokeLinejoin="round" className="feather feather-minus">
                                <line x1="5" y1="12" x2="19" y2="12"></line>
                            </svg><span>USUARIO</span></div>
                    </li>

                    <li className="menu">
                        <a href="#users" data-toggle="collapse" aria-expanded="false" className="dropdown-toggle">
                            <div className="">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                                    strokeLinejoin="round" className="feather feather-users">
                                    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                                    <circle cx="9" cy="7" r="4"></circle>
                                    <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                                    <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                                </svg>
                                <span>USUARIO</span>
                            </div>
                            <div>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                                    strokeLinejoin="round" className="feather feather-chevron-right">
                                    <polyline points="9 18 15 12 9 6"></polyline>
                                </svg>
                            </div>
                        </a>
                        <ul className="collapse submenu list-unstyled" id="users" data-parent="#accordionExample">
                           
                           
                        </ul>
                    </li>

                    <li className="menu">
                        <a href="#pages" data-toggle="collapse" aria-expanded="false" className="dropdown-toggle">
                            <div className="">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                                    strokeLinejoin="round" className="feather feather-file">
                                    <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path>
                                    <polyline points="13 2 13 9 20 9"></polyline>
                                </svg>
                                <span>CONTÁCTANOS</span>
                            </div>
                            <div>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                                    strokeLinejoin="round" className="feather feather-chevron-right">
                                    <polyline points="9 18 15 12 9 6"></polyline>
                                </svg>
                            </div>
                        </a>
                        <ul className="collapse submenu list-unstyled" id="pages" data-parent="#accordionExample">
                           
                         
                             
                        </ul>
                    </li>

                </ul>

            </nav>

        </div>
        
        */